import type { ReactNode } from "react"
import "./styles.css"

export function Main({ children }: { children: ReactNode }) {
  return <main className="main-content">{children}</main>
}

export default Main
